module.exports = __webpack_public_path__ + "static/img/8.dfaab5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/8.png
// module id = UvPo
// module chunks = 0